import { render, staticRenderFns } from "./DuplicatePopover.vue?vue&type=template&id=6568b3d0&scoped=true&"
import script from "./DuplicatePopover.vue?vue&type=script&lang=js&"
export * from "./DuplicatePopover.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePopover.vue?vue&type=style&index=0&id=6568b3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6568b3d0",
  null
  
)

export default component.exports